package com.fireavert.yardi.common_data.data_models.responses


import kotlinx.serialization.Serializable


@Serializable
data class YardiPropertyListItemData(
    val code: String,
    val marketingName: String,
    val addressLine1: String,
    val addressLine2: String?,
    val addressLine3: String?,
    val city: String,
    val state: String,
    val postalCode: String
)

@Serializable
data class PropertyWithUnitsData(
    val code: String,
    val marketingName: String?,
    val units: List<YardiUnitData>
)

@Serializable
data class NumberOccupantsData(
    val total: Int,
    val child: Int?
)

@Serializable
data class AddressData(
    val addressLine1: String?,
    val addressLine2: String?,
    val city: String?,
    val state: String?,
    val province: String?,
    val postalCode: String?,
    val country: String?,
    val countyName: String?,
    val unparsedAddress: String?,
    val addressType: String?
)

@Serializable
data class YardiUnitData(
    val uniqueId: String?,
    val unitId: String,
    val marketingName: String?,
    val identificationValues: Map<String, String>?,
    val unitType: String?,
    val unitBedrooms: Double?,
    val unitBathrooms: Double?,
    val floorPlanName: String?,
    val minSquareFeet: Double?,
    val maxRentableArea: Double?,
    val squareFootType: String?,
    val marketRent: Double?,
    val unitRent: Double?,
    val unitEconomicStatus: String?,
    val unitEconomicStatusDescription: String?,
    val unitOccupancyStatus: String?,
    val unitLeasedStatus: String?,
    val unitLeasedStatusDescription: String?,
    val occupied: Boolean,
    val availableDate: String?,
    val leaseExpirationDate: String?,
    val numberOfOccupants: NumberOccupantsData?,
    val currentResident: ResidentInfoData?,
    val approvedApplicant: ApplicantInfoData?,
    val amenities: List<AmenityData>,
    val addresses: List<AddressData>,
    val phaseName: String?,
    val buildingName: String?,
    val floorData: String?
)

@Serializable
data class ResidentInfoData(
    val tCode: String,
    val firstName: String,
    val lastName: String,
    val moveInDate: String,
    val moveOutDate: String?
)

@Serializable
data class ApplicantInfoData(
    val applicationId: String,
    val firstName: String,
    val lastName: String,
    val approvalDate: String,
    val expectedMoveIn: String?
)

@Serializable
data class AmenityData(
    val code: String,
    val description: String,
    val value: String?
)